import React from 'react';

import FormError from '../FormError';
import Option from './Option';
import Radio from './Radio';

const RadioGroup = ({
  name,
  variant = '',
  title,
  options = [],
  register,
  defaultChecked,
  error,
}) => (
  <div>
    {title && <span>{title}</span>}

    {options.length &&
      options.map(({ id, label, value, image, subtitle, details }) =>
        variant ? (
          <Option
            key={id}
            id={id}
            name={name}
            variant={variant}
            title={label}
            subtitle={subtitle}
            image={image}
            details={details}
            register={register}
            error={error}
            defaultChecked={defaultChecked === id}
            value={value}
          />
        ) : (
          <Radio
            key={id}
            id={id}
            name={name}
            label={label}
            register={register}
            error={error}
            defaultChecked={defaultChecked === id}
            value={value}
          />
        ),
      )}

    {error && <FormError>{error.message}</FormError>}

    <style jsx>{`
      div {
        margin-bottom: 32px;
      }

      span {
        display: block;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 16px;
      }
    `}</style>
  </div>
);

export default RadioGroup;
